import {get, post, put, del} from "@/utils/request";

// 新增用户和分类权限
export function addUserClassify(data) {
    return post('/userClassify/add', data)
}
//查询管理员所管理的分类
export function selectClassify(data){
    return get('/category/adminList/'+data)
}
//根据员工号查询分类
export function selectClassifyByUserName(userName){
    return get('/userClassify/userClassifyList/'+userName)
}
//修改用户和分类权限
export function updateUserClassify(data){
    return put('/userClassify/update',data)
}
//删除根据用户名
export function deleteUserClassify(data){
    return del('/userClassify/delete',data)
}
//根据用户名查询员工信息（搜索框）
export function queryUserInfo(data){
    return get('/userClassify/list',data)
}
//根据用户名查询员工信息（新增对话框）
export function queryUserInfoInput(data){
    return get('/userClassify/userInfo/'+data)
}